import React from "react";
import { CHAPTERS, PRIMARY_TEL } from "@/data";
import { Reveal, Overline } from "@/components/Reveal";
import { Phone } from "lucide-react";

export const Chapters = () => (
  <section id="experience" className="scroll-mt-24 border-t border-white/10 bg-background py-24 md:py-32">
    <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
      <Reveal>
        <Overline>The Admiral Experience</Overline>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="mt-4 max-w-3xl font-serif text-4xl font-light leading-tight tracking-tight text-white md:text-5xl">
          Easy, safe, and hassle-free — from the first tap to the final mile.
        </h2>
      </Reveal>

      <div className="mt-20 divide-y divide-white/10 border-y border-white/10">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.no} delay={i * 0.05}>
            <div className="group grid grid-cols-1 gap-6 py-12 transition-colors duration-500 hover:bg-white/[0.02] md:grid-cols-12 md:items-baseline md:px-4">
              <div className="font-serif text-5xl font-light text-primary md:col-span-2">{c.no}</div>
              <h3 className="font-serif text-3xl font-light text-white md:col-span-5">{c.title}</h3>
              <p className="text-sm font-light leading-relaxed text-zinc-400 md:col-span-5">{c.body}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <div className="mt-16 flex flex-wrap items-center gap-4">
          <button
            onClick={() => document.querySelector("#book")?.scrollIntoView({ behavior: "smooth" })}
            data-testid="chapters-book-button"
            className="bg-primary px-8 py-4 text-xs font-medium uppercase tracking-[0.2em] text-primary-foreground transition-all duration-300 hover:tracking-[0.3em]"
          >
            Book a Ride
          </button>
          <a href={`tel:${PRIMARY_TEL}`} className="group flex items-center gap-3 text-xs uppercase tracking-[0.2em] text-white transition-colors hover:text-primary">
            <Phone className="h-4 w-4 text-primary" /> Or call us 24/7
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
